import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-sm-6" }
const _hoisted_2 = { class: "row g-0" }
const _hoisted_3 = { class: "col-md-5" }
const _hoisted_4 = { class: "col-md-7" }
const _hoisted_5 = { class: "d-flex flex-column h-100" }
const _hoisted_6 = { class: "title d-flex align-items-center flex-grow-1 px-8" }
const _hoisted_7 = { class: "h3 text-fprimary m-0" }
const _hoisted_8 = { class: "card-text d-flex flex-column px-8" }
const _hoisted_9 = { class: "d-flex flex-row align-items-center mb-4 w-100" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-geo-alt fs-1 text-fsecondary me-4" }, null, -1)
const _hoisted_11 = { class: "d-flex flex-column" }
const _hoisted_12 = { class: "fw-bolder" }
const _hoisted_13 = { class: "d-flex justify-content-between" }
const _hoisted_14 = { class: "d-flex flex-row align-items-center w-100" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar2-week fs-1 text-fsecondary me-4" }, null, -1)
const _hoisted_16 = { class: "d-flex flex-column" }
const _hoisted_17 = { class: "fw-bolder" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "d-flex flex-row align-items-center w-100" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-workspace fs-1 text-fsecondary me-4" }, null, -1)
const _hoisted_21 = { class: "d-flex flex-column" }
const _hoisted_22 = { class: "fw-bolder" }
const _hoisted_23 = {
  class: "d-flex justify-content-center bg-fprimary py-5 mt-8",
  style: {"border-bottom-right-radius":"6px"}
}
const _hoisted_24 = {
  type: "button",
  class: "btn btn-fsecondary btn-sm text-white"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: _ctx.to,
      class: "card mb-8 shadow text-black border border-2 border-fprimary border-hover"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_image, {
              class: "w-100 h-300px",
              src: _ctx.evento?.logo,
              fit: 'contain'
            }, null, 8, ["src"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.evento?.name), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.t("place")), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.evento?.place), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.t("date")), 1),
                      _createElementVNode("span", {
                        innerHTML: _ctx.getDate(_ctx.evento?.startdate, _ctx.evento?.enddate)
                      }, null, 8, _hoisted_18)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.t("modality")), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.evento?.modality == 'V' ? 'Virtual' : 'Presencial'), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("button", _hoisted_24, _toDisplayString(_ctx.t("details")), 1)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["to"])
  ]))
}